export default "__VITE_ASSET__Z6O4XQNp__"